import store from '@/store'
import axios from 'axios'

export default {
  async getIntegrationConfig() {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.get(store.getters.getIntegratorApi + '/company/config', headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log('error', error.e)
      return {error: true, code: 500, msg: 'Não foi possível obter dados da integração'}
    }
  },

  async saveIntegrationConfig(ean_black_list) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let data = {
        ean_black_list: ean_black_list
      }
      let result = await axios.patch(store.getters.getIntegratorApi + '/company/config', data, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Não foi possível salvar dados da integração'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, data: error, msg: 'Não foi possível salvar dados da integração'}
    }
  }
}
